import axiosClient from '../clients/AxiosClient';
import { ResidentialIncentiveApiData } from '../types/ResidentialIncentivesDataType';

const getResidentialIncentives = async (zipCode: string) => {
    return await axiosClient.get<ResidentialIncentiveApiData[]>(
        `/v1/incentives/residential/${zipCode}`,
    );
};

export default getResidentialIncentives;
